import React from 'react';
import ChapterPage from "../ChapterPage";
import ContentPage from "../ContentPage";
import {getData} from "../../requests/CRUD";
import {TRAINING} from "../../consts/tables";

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: '',
        };
    }

    componentDidMount() {
        this.fetch(this.props.params);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
            this.fetch(nextProps.params);
    }

    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');

        getData({
            tableCode: TRAINING,
            options: {
                filter: [{
                    text: '',
                    code: 'DELETED',
                    type: 'null',
                }, {
                    text: subchapterParentSlug,
                    code: 'PARENT_SLUG',
                    type: 'exact',
                }],
                filterType: 'and',
            }
        }).then(res => {
            if (res && res.success) {
                if (res.data.length) {
                    this.setState({page: 'chapter'});
                    return;
                }
                this.setState({page: 'content'});
            }
        });
    }

    render() {
        if (this.state.page === 'chapter')
            return <ChapterPage {...this.props}/>;
        if (this.state.page === 'content')
            return <ContentPage {...this.props}/>;
        return (
            <div className='page-rounded-corner-container'>
                <div className='page-header-container training'/>
            </div>
        )
    }
}